import { useEffect, useState } from "react";

import { SEC_IN_DAY, SEC_IN_HOUR, SEC_IN_MINUTE } from "../constants";

const pad2 = (value) => (value < 10 ? `0${value}` : `${value}`);

/**
 * Format a time duration:
 * - >= 1 day: DDd HHh
 * - >= 1 hour and < 1 day: HHh MMm
 * - < 1 hour: MMm SSs
 */
const formatTime = (seconds) => {
  const totalSeconds = Math.max(0, Math.trunc(seconds ?? 0));

  if (totalSeconds >= SEC_IN_DAY) {
    const days = Math.floor(totalSeconds / SEC_IN_DAY);
    const hours = Math.floor((totalSeconds % SEC_IN_DAY) / SEC_IN_HOUR);
    return `${pad2(days)}d ${pad2(hours)}h`;
  }

  if (totalSeconds >= SEC_IN_HOUR) {
    const hours = Math.floor(totalSeconds / SEC_IN_HOUR);
    const minutes = Math.floor((totalSeconds % SEC_IN_HOUR) / SEC_IN_MINUTE);
    return `${pad2(hours)}h ${pad2(minutes)}m`;
  }

  const minutes = Math.floor(totalSeconds / SEC_IN_MINUTE);
  const secs = totalSeconds % SEC_IN_MINUTE;
  return `${pad2(minutes)}m ${pad2(secs)}s`;
};

export const useTimer = () => {
  const [timeLeft, setTimeLeft] = useState();
  const [isDone, setIsDone] = useState(false);
  const [timeFormatted, setTimeFormatted] = useState();
  const [pause, setPause] = useState();

  useEffect(() => {
    if (!pause) {
      const intervalId = setInterval(() => {
        setTimeLeft((t) => (t > 0 ? t - 1 : t));
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [pause]);

  useEffect(() => {
    setIsDone(timeLeft <= 0);
    setTimeFormatted(formatTime(timeLeft ?? 0));
  }, [timeLeft]);

  const setTimer = (time) => {
    setTimeLeft(Math.trunc(time));
    setPause();
  };

  return {
    setTimer,
    timeLeft,
    isDone,
    timeFormatted,
    pause: () => setPause(true),
  };
};
